// import node module libraries
import React from 'react';
import { Link, useSearchParams } from 'react-router';
import { useMediaQuery } from 'react-responsive';
import { Image, NavDropdown } from 'react-bootstrap';
import { Row, Col } from 'react-bootstrap';

// import data files
import NavbarMegaMenuRoutes from '../../../../routes/NavbarMegaMenuRoutes';
import { FaCheckCircle } from 'react-icons/fa';
import { useOrchestrator } from '../../../../redux/ducks/orchestrator';
import { useAuth } from '../../../../redux/ducks/auth';
import { isBooleanFalse } from '../../../../utils/objectUtils';

const MegaMenu = () => {
	//#region useSearchParams

	const [searchParams, setSearchParams] = useSearchParams();

	//#endregion
	//#region useOrchestrator

	const { products } = useOrchestrator();

	//#endregion
	//#region useAuth

	const { authContext } = useAuth();

	//#endregion

	const isDesktop = useMediaQuery({
		query: '(min-width: 992px)'
	});

	const MegaMenuDesktop = () => {
		return (
			<div className="nav-item dropdown dropdown-fullwidth">
				<Link
					className="nav-link dropdown-toggle"
					to="#"
					data-bs-toggle="dropdown"
					aria-haspopup="true"
					aria-expanded="false"
				>
					All Medications
				</Link>
				<div className="dropdown-menu dropdown-menu-md">
					<div className="px-4 pt-2 pb-2">
						<Row>
							<Col xs={12}>
								<div className="lh-1 mb-5">
									<span className="text-uppercase text-ready-black fw-semi-bold ls-md">
										Explore
									</span>
									{/* <p>
										<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Doctor Approved</span>
										<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Scientifically Proven</span>
										<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Customized For You</span>
									</p> */}
								</div>
							</Col>
							{NavbarMegaMenuRoutes(authContext, products).filter(i => !isBooleanFalse(i.show)).map((item, index) => {
								return (
									<Col lg={4} xs={12} key={index}>
										<div className="border-bottom pb-2 mb-3">
											<h5 className="mb-0 fs-1125">{item.menuitem}</h5>
										</div>
										{item.children.filter(i => !isBooleanFalse(i.show)).map((subitem, subindex) => {
											return subitem.button ? (
												<div className="mt-4" key={subindex}>
													<Link to={{ pathname: subitem.link, search: searchParams.toString() }} className="btn btn-outline-primary btn-sm">
														{subitem.menuitem}
													</Link>
												</div>
											) : (
												<div className="" key={subindex}>
													<Link to={{ pathname: subitem.link, search: searchParams.toString() }} className="text-decoration-none">
														<div className="d-flex mb-3">
															<div className="d-inline-flex align-items-center justify-content-center bg-ready-pearl rounded-2" style={{ maxHeight: 60, height: 60, minWidth: 60, maxWidth: 60, width: 60 }}>
																<Image src={subitem.image} alt="" className="bg-ready-pearl object-fit-cover p-1 rounded-2" style={{ height: 60, width: 60 }} />
															</div>
															<div className="ms-2">
																<h6 className="mb-0 fs-4">{subitem.menuitem}</h6>
																<small className="text-body">
																	{subitem.subtitle}
																</small>
															</div>
														</div>
													</Link>
												</div>
											);
										})}
									</Col>
								);
							})}
						</Row>
					</div>
				</div>
			</div>
		);
	};

	const MegaMenuMobile = () => {
		return (
			<NavDropdown
				title="Treatments"
				className="dropdown-fullwidth"
				id="basic-nav-dropdown"
			>
				<NavDropdown.Item as="div" className="py-2 px-3 dropdown-item-megamenu">
					<Row>
						{/* <Col lg={12} md={12} xs={12} className="lh-1 mb-1">
							<h3 className="mb-1">Increase your healthspan and live a longer, healthier life with Ready<sup>RX</sup></h3>
							<p className="text-wrap">
								<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Doctor Approved</span>
								<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Scientifically Proven</span>
								<span className="text-nowrap me-2 d-inline-flex align-items-center justify-content-center"><FaCheckCircle className="text-success me-2" />Customized For You</span>
							</p>
						</Col> */}
						{NavbarMegaMenuRoutes(authContext, products).filter(i => !isBooleanFalse(i.show)).map((item, index) => {
							return (
								<Col lg={4} xs={12} key={index}>
									<div className="border-bottom pb-2 mb-3">
										<h5 className="mb-0">{item.menuitem}</h5>
									</div>
									{item.children.filter(i => !isBooleanFalse(i.show)).map((subitem, subindex) => {
										return subitem.button ? (
											<div className="mt-4" key={subindex}>
												<Link to={{ pathname: subitem.link, search: searchParams.toString() }} className="btn btn-outline-primary btn-sm mb-2">
													{subitem.menuitem}
												</Link>
											</div>
										) : (
											<div className="" key={subindex}>
												<Link to={{ pathname: subitem.link, search: searchParams.toString() }} className="text-decoration-none">
													<div className="d-flex mb-3">
														<div className="d-inline-flex align-items-center justify-content-center bg-ready-pearl rounded-2" style={{ maxHeight: 60, height: 60, minWidth: 60, maxWidth: 60, width: 60 }}>
															<Image src={subitem.image} alt="" className="bg-ready-pearl object-fit-cover p-1 rounded-2" style={{ height: 60, width: 60 }} />
														</div>
														<div className="ms-2">
															<h6 className="mb-0">{subitem.menuitem}</h6>
															<small className="text-body">
																{subitem.subtitle}
															</small>
														</div>
													</div>
												</Link>
											</div>
										);
									})}
								</Col>
							);
						})}
					</Row>
				</NavDropdown.Item>
			</NavDropdown>
		);
	};

	return (
		<React.Fragment>{isDesktop ? <MegaMenuDesktop /> : <MegaMenuMobile />}</React.Fragment>
	);
};

export default MegaMenu;